import React from "react";
import { useTheme, Typography } from "@mui/material";
import DefaultBlock from "./DefaultBlock";

export default function BlueprintBlock({ text, width = "1400px" }) {
  const theme = useTheme();

  return (
    <DefaultBlock width={width}>
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: 8,
          left: 12,
          fontFamily: "monospace",
          color: theme.palette.text.secondary,
          opacity: 0.7,
          userSelect: "none",
        }}
      >
        {text}
      </Typography>
    </DefaultBlock>
  );
}
